import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    key: 'MjcwLjEwNDM1LjU3Ng',
    secret: 'b2cd38e43e1fc6bee16b8b4428012d96',
  },
  getters: {
  },
  mutations: {
    setToken(state, item) {
      state.token = item;
    },
    setKey(state, item) {
      state.key = item;
    },
    setSecret(state, item) {
      state.secret = item;
    },
  },
  actions: {
    increment(context) {
      context.commit('increment')
    }
  },
  modules: {
  }
})
